export default __webpack_public_path__ + "assets/ca6e807.ico";